import React from "react";
import { Link } from "react-router-dom";
import Ad from "../components/Ad";
import rewritten_guide_banner from "../assets/images/rewritten_guide_banner.png";
import rewritten_guide_banner_cog_version from "../assets/images/rewritten_guide_banner_cog_version.png";

class Home extends React.Component {
    render() {
        return (
            <>
                <div className="logo">
                    <img
                        className="toonImg"
                        src={rewritten_guide_banner}
                        alt="Spike's Rewritten Guide"
                    />
                    <img
                        className="cogImg"
                        src={rewritten_guide_banner_cog_version}
                        alt="Spike's Rewritten Guide"
                    />
                </div>
                <div className="panel">
                    <div className="panel-content">
                        <h1>Welcome Toons!</h1>
                        <p>
                            Spike's Rewritten Guide is a one stop site with all
                            the in's and out's of Toontown Rewritten, written by
                            your very own, Spike. This guide can be used by new
                            users who need some tips for gameplay or old users
                            who may need a slight reminder of some things.
                            Updates and additions will be added as time goes on,
                            so be sure to stop by every once in a while!
                        </p>
                        <p>
                            Check out <Link to="/whatsnew">What's New</Link>{" "}
                            here at Spike's Rewritten Guide!
                        </p>
                        <a
                            href="https://www.buymeacoffee.com/spikesrewrittenguide"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button><span role="img" aria-label="Pie emoji">🥧</span>{" "}
                                Buy me a gag
                            </button>
                        </a>
                        <hr />
                        <Link to="/activities">
                            <h2>Activities</h2>
                        </Link>
                        <p>
                            Head over to <Link to="/activities">Activities</Link> to gain some insight
                            on the various fun and extra activities, that is not
                            just cog fighting, you can do in Toontown to have some
                            extra fun and to possibly gain more laff points for your toon. Here, you can
                            also to learn about doodles and how they can be a
                            valuable aid for you and your toon peers.
                        </p>
                        <Link to="/cogs">
                            <h2>Cogs</h2>
                        </Link>
                        <p>
                            Check out the <Link to="/cogs">Cogs</Link> page to learn a lot about
                            each cog tier, their respective cog headquarters,
                            and where you can find certain cogs across Toontown.
                            Additionally, you can discover what you can do in
                            each cog headquarters and how you can be successful
                            in those types of cog related activities.
                        </p>
                        <Link to="/neighborhoods">
                            <h2>Neighborhoods</h2>
                        </Link>
                        <p>
                            Make your way over to <Link to="/neighborhoods">Neighborhoods</Link> to learn
                            more about what all the playgrounds across Toontown
                            have to offer! Gain more insight on the main
                            campaign, clothing shops, and much more.
                        </p>
                        <Link to="/toontips">
                            <h2>Toon Tips</h2>
                        </Link>
                        <p>
                            Navigate on over to the <Link to="/toontips">Toon Tips</Link> page to
                            access a quick reference on important tips to
                            enahnce your gameplay experience. These tips can
                            include advice about invasions, gag training,
                            fighting strategies, communication, etc.
                        </p>
                        <Ad dataAdSlot="1733984228" />
                    </div>
                </div>
            </>
        );
    }
}

export default Home;
